import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyCompanyCode = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({
            url: 'getCompanyCode'
        })
            .then((result) => {
                if(result?.data?.resultSet?.length){
                    setcontent(result.data.resultSet)
                }
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.id
            temp.text = `${object.companyCode}`
            temp.value = object.companyCode
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MyCompanyCode